import {
  PROFESSIONAL_ACCESS_ROLES_FETCHED_SUCCESS,
  PROFESSIONAL_ACCESS_ROLES_FETCHED_FAILURE,
} from './types';
import { logger } from '../logger';

const log = logger();

const professionalAccessRolesFetchedAction =
  (status) => async (dispatch) => {
    try {
      dispatch({
        type: PROFESSIONAL_ACCESS_ROLES_FETCHED_SUCCESS,
        payload: status,
      });
    } catch (err) {
      log.error(
        'Error dispatching professional details fetched action',
        err,
      );
      dispatch({
        type: PROFESSIONAL_ACCESS_ROLES_FETCHED_FAILURE,
        payload: status,
      });
    }
  };

export default professionalAccessRolesFetchedAction;
